
import { Bind } from "@eusoft/webapp-core/Bind";
import { Class } from "@eusoft/webapp-jsx";
import  { NodeView } from "@eusoft/webapp-ui";
import type { ViewNode } from "@eusoft/webapp-ui/types";

interface IFieldOptions {
    label: ViewNode;
    content: ViewNode | boolean;
    openAsync?: () => Promise<unknown> | unknown;
    canOpen?: boolean;
}

export function Field(options: IFieldOptions) {

    return <div className="field" on-click={() => options?.openAsync()}>
        <Class name="can-open" condition={options.canOpen}/>
        <Class name="empty" condition={
            options.content === null ||
            options.content === undefined ||
            options.content === false ||
            (typeof options.content == "string" && options.content.length == 0)} />

        <label><NodeView>{options.label}</NodeView></label>
        <div className="value">{options.content as ViewNode}</div>
    </div>
}